import _ from 'underscore';

import DataConnector from 'connect/DataConnector';
import {isSchemaTag} from 'folder-items/FileConstants';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {DataMissing} from 'results/reduceResults';
import {tagHasValue} from 'schemas/tags/TagUtil';
import pick from 'util/pick';

import {AssayResult} from '../assays/AssayRecordConstants';
import {AssayValidationByResultId, FieldHasValueDictByResultId} from './ValidationConstants';

function _getFieldHasValueDictsByResultId(
  assayResultsById: {[id: string]: AssayResult | DataMissing},
  resultIdsForFetch: Array<string>
): FieldHasValueDictByResultId {
  const relevantAssayResultsById = pick(assayResultsById, ...resultIdsForFetch) as {
    [id: string]: AssayResult;
  };
  return _.mapObject(relevantAssayResultsById, (assayResult) => {
    const idsToValuesList = _.compact(
      assayResult.allTags.map((tag) =>
        isSchemaTag(tag) ? {[tag.tagSchemaField.apiId]: tagHasValue(tag)} : null
      )
    );
    return Object.assign({}, ...idsToValuesList);
  });
}

export interface TableAssayValidationEnhancedProps {
  assayValidationByResultId: AssayValidationByResultId | null;
  fieldHasValueDictByResultId: FieldHasValueDictByResultId | null;
}

export default function getOrFetchResultValidationInConnector<
  P extends {},
  E extends TableAssayValidationEnhancedProps,
>(connector: DataConnector<P, E>, resultIdsForFetch: Array<string>): TableAssayValidationEnhancedProps {
  let assayValidationByResultId = null;
  let fieldHasValueDictByResultId = null;
  if (resultIdsForFetch.length > 0) {
    assayValidationByResultId = connector.getOrFetchMultipleOptionalDeprecated(
      ManagedModelType.ASSAY_RESULT_VALIDATION,
      resultIdsForFetch,
      true
    );
    fieldHasValueDictByResultId = _getFieldHasValueDictsByResultId(
      connector.reduxState().models.results.assayResultsById,
      resultIdsForFetch
    );
  }
  return {assayValidationByResultId, fieldHasValueDictByResultId};
}
